import React from 'react';
import styled, { css } from 'styled-components';

import { convertThumbnailToPictureProps } from '@tager/web-modules';

import useSettingItem from '@/hooks/useSettingItem';
import Picture from '@/components/Picture';
import { colors } from '@/constants/theme';
import { media } from '@/utils/mixin';

interface Props {
  isPurchasePage?: boolean;
}

function Pay({ isPurchasePage }: Props) {
  const logos = useSettingItem('FOOTER_LOGOS');
  const purchaseLogos = useSettingItem('FOOTER_CHECKOUT_PAYMENT_LOGOS');

  const items = isPurchasePage ? purchaseLogos : logos;

  if (!items || !items.length) {
    return null;
  }

  return (
    <Component>
      <List>
        {items.map((item, index) => {
          return (
            <Item key={index}>
              <Picture
                loading="lazy"
                {...convertThumbnailToPictureProps(item)}
              />
            </Item>
          );
        })}
      </List>
    </Component>
  );
}

export default Pay;

const Component = styled.div``;

const List = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: -5px -10px;

  ${media.mobileUp(
    css`
      justify-content: flex-end;
    `
  )}
`;

const Item = styled.span`
  margin: 5px 10px;

  picture,
  img {
    max-width: 110px;
    height: 25px;

    svg {
      fill: ${colors.white};
      opacity: 0.4;
    }
  }
`;
